// Читалка косяка: всплывает по наведению на маркер, клик открывает форму правки.
// Только чтение — в форме те же поля живут виджетами, дублировать ввод незачем.
// Прозрачна для мыши: наползая на курсор, она уводила бы его с точки и гасила
// сама себя (та же причина, что у незакреплённой VesselCard).

import type { Cluster, SpeciesItem } from '../api'
import { useT } from '../i18n'
import { MapCallout } from '../map/MapCallout'
import { clusterPeekLines } from './clusterPeekView'

interface ClusterPeekProps {
  cluster: Cluster
  species: SpeciesItem[]
}

export function ClusterPeek({ cluster, species }: ClusterPeekProps) {
  const t = useT()
  const lines = clusterPeekLines(cluster, species)

  return (
    // Привязка к САМОЙ отметке, а не к курсору: читалка рассказывает про косяк,
    // а курсор гуляет по его кружку.
    <MapCallout anchor={{ lng: cluster.lon, lat: cluster.lat }} width={224} pinned={false}>
      <div className="truncate text-sm font-semibold text-foam" title={lines.title}>
        {lines.title}
      </div>
      <dl className="mt-2 space-y-1 text-[12px]">
        <div className="flex items-baseline justify-between gap-2">
          <dt className="shrink-0 text-faint">{t('models.cluster.sizeLabel')}</dt>
          <dd className="min-w-0 truncate text-right font-medium text-foam">{lines.size}</dd>
        </div>
        <div className="flex items-baseline justify-between gap-2">
          <dt className="shrink-0 text-faint">{t('models.cluster.observedLabel')}</dt>
          <dd className="min-w-0 truncate text-right font-medium text-foam">{lines.when}</dd>
        </div>
      </dl>
      {lines.note && <div className="mt-2 text-[12px] text-mist">{lines.note}</div>}
      <div className="mt-2 text-[11px] text-faint">{t('models.cluster.clickToEdit')}</div>
    </MapCallout>
  )
}
